import styled from 'styled-components';
import { textStyleCss } from 'src/theme/atlas';

export const HeaderContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
`;

export const SubheaderContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 20px;
`;

export const AccessContainer = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const AccessName = styled.p`
  color: ${(props) => props.theme.atlas.semantic.color.type.default};
  ${({ theme }) => textStyleCss(theme.atlas.typography.semantic.caption)}
  margin: 5px 0;
`;

export const AccessPermissions = styled.p`
  color: ${(props) => props.theme.atlas.semantic.color.type.default};
  ${({ theme }) => textStyleCss(theme.atlas.typography.semantic.caption)}
  margin: 5px 0;
`;
